import Button from '../../../shared/Button';
import DropdownIcon from 'imagesUwKluis/svg/dropdown.svg';
import { Box, Flex } from '../../../shared/layouts';
import { currencyFormatter } from "@dnhb/formatters";

const CalculationButton = ({ onClick, name, output }) => {
  const maxResult = currencyFormatter(output?.max_mortgage, 0);

  return (
    <Button
      width={'100%'}
      onClick={onClick}
      css={({ colors, space }) => ({
        backgroundColor: colors?.primaryBackground,
        color: colors?.primaryFont,
        paddingLeft: space.m,
        paddingRight: space.m
      })}
    >
      <Flex
        justifyContent={'space-between'}
        alignItems={'center'}
        width={'100%'}
      >
        <Box fontWeight={'bold'} textAlign={'left'}>
          {name}
          {maxResult && (
            <span css={{ whiteSpace: 'nowrap' }}>{` \u00BB ${maxResult}`}</span>
          )}
        </Box>
        <DropdownIcon
          width={'1rem'}
          height={'1rem'}
          css={({ colors }) => ({
            fill: colors?.primaryFont,
            transform: 'rotate(-90deg)'
          })}
        />
      </Flex>
    </Button>
  );
}

export default CalculationButton;
